import FooterNavBlock from './FooterNavBlock';

export default FooterNavBlock;
